"use strict";
/**
 * DO NOT CHANGE
 *
 * This file is auto-generated by the `scripts/generate-asset-mapping.js` script. Manually
 * modifying it will result in your build breaking.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureIconAsset = exports.PublishedSegmentExampleAsset = exports.CompanyLogoAsset = exports.CompanySymbolAsset = exports.CountryIconAsset = exports.PaymentIconAsset = exports.SocialIconAsset = exports.AvatarCompanyLogoAsset = exports.ActionableSecondaryIllustrationAsset = exports.SecondaryIllustrationAsset = exports.PrimaryIllustrationAsset = exports.IconAsset = void 0;
var STATIC_ASSET_URL = 'https://6si-static-cdn.6sense.com/6ds/assets/6162fea943495a74a055fadb20f17574';
exports.IconAsset = {
    'activity-heart': STATIC_ASSET_URL + "/icons/activity-heart.svg",
    'activity': STATIC_ASSET_URL + "/icons/activity.svg",
    'airplay': STATIC_ASSET_URL + "/icons/airplay.svg",
    'airpods': STATIC_ASSET_URL + "/icons/airpods.svg",
    'alarm-clock-check': STATIC_ASSET_URL + "/icons/alarm-clock-check.svg",
    'alarm-clock-minus': STATIC_ASSET_URL + "/icons/alarm-clock-minus.svg",
    'alarm-clock-off': STATIC_ASSET_URL + "/icons/alarm-clock-off.svg",
    'alarm-clock-plus': STATIC_ASSET_URL + "/icons/alarm-clock-plus.svg",
    'alarm-clock': STATIC_ASSET_URL + "/icons/alarm-clock.svg",
    'alert-circle': STATIC_ASSET_URL + "/icons/alert-circle.svg",
    'alert-triangle': STATIC_ASSET_URL + "/icons/alert-triangle.svg",
    'align-bottom-arrow': STATIC_ASSET_URL + "/icons/align-bottom-arrow.svg",
    'align-center': STATIC_ASSET_URL + "/icons/align-center.svg",
    'align-horizontal-center': STATIC_ASSET_URL + "/icons/align-horizontal-center.svg",
    'align-justify': STATIC_ASSET_URL + "/icons/align-justify.svg",
    'align-left-arrow': STATIC_ASSET_URL + "/icons/align-left-arrow.svg",
    'align-left': STATIC_ASSET_URL + "/icons/align-left.svg",
    'align-right-arrow': STATIC_ASSET_URL + "/icons/align-right-arrow.svg",
    'align-right': STATIC_ASSET_URL + "/icons/align-right.svg",
    'align-top-arrow': STATIC_ASSET_URL + "/icons/align-top-arrow.svg",
    'align-vertical-center': STATIC_ASSET_URL + "/icons/align-vertical-center.svg",
    'anchor': STATIC_ASSET_URL + "/icons/anchor.svg",
    'annotation-alert': STATIC_ASSET_URL + "/icons/annotation-alert.svg",
    'annotation-check': STATIC_ASSET_URL + "/icons/annotation-check.svg",
    'annotation-dots': STATIC_ASSET_URL + "/icons/annotation-dots.svg",
    'annotation-heart': STATIC_ASSET_URL + "/icons/annotation-heart.svg",
    'annotation-info': STATIC_ASSET_URL + "/icons/annotation-info.svg",
    'annotation-plus': STATIC_ASSET_URL + "/icons/annotation-plus.svg",
    'annotation-question': STATIC_ASSET_URL + "/icons/annotation-question.svg",
    'annotation-x': STATIC_ASSET_URL + "/icons/annotation-x.svg",
    'annotation': STATIC_ASSET_URL + "/icons/annotation.svg",
    'announcement': STATIC_ASSET_URL + "/icons/announcement.svg",
    'archive': STATIC_ASSET_URL + "/icons/archive.svg",
    'arrow-circle-down-left': STATIC_ASSET_URL + "/icons/arrow-circle-down-left.svg",
    'arrow-circle-down-right': STATIC_ASSET_URL + "/icons/arrow-circle-down-right.svg",
    'arrow-circle-down': STATIC_ASSET_URL + "/icons/arrow-circle-down.svg",
    'arrow-circle-left': STATIC_ASSET_URL + "/icons/arrow-circle-left.svg",
    'arrow-circle-right': STATIC_ASSET_URL + "/icons/arrow-circle-right.svg",
    'arrow-circle-up-left': STATIC_ASSET_URL + "/icons/arrow-circle-up-left.svg",
    'arrow-circle-up-right': STATIC_ASSET_URL + "/icons/arrow-circle-up-right.svg",
    'arrow-circle-up': STATIC_ASSET_URL + "/icons/arrow-circle-up.svg",
    'arrow-narrow-down-left': STATIC_ASSET_URL + "/icons/arrow-narrow-down-left.svg",
    'arrow-narrow-down-right': STATIC_ASSET_URL + "/icons/arrow-narrow-down-right.svg",
    'arrow-narrow-down': STATIC_ASSET_URL + "/icons/arrow-narrow-down.svg",
    'arrow-narrow-left': STATIC_ASSET_URL + "/icons/arrow-narrow-left.svg",
    'arrow-narrow-right': STATIC_ASSET_URL + "/icons/arrow-narrow-right.svg",
    'arrow-narrow-up-left': STATIC_ASSET_URL + "/icons/arrow-narrow-up-left.svg",
    'arrow-narrow-up-right': STATIC_ASSET_URL + "/icons/arrow-narrow-up-right.svg",
    'arrow-narrow-up': STATIC_ASSET_URL + "/icons/arrow-narrow-up.svg",
    'arrows-down': STATIC_ASSET_URL + "/icons/arrows-down.svg",
    'arrows-left': STATIC_ASSET_URL + "/icons/arrows-left.svg",
    'arrows-right': STATIC_ASSET_URL + "/icons/arrows-right.svg",
    'arrows-triangle': STATIC_ASSET_URL + "/icons/arrows-triangle.svg",
    'arrows-up': STATIC_ASSET_URL + "/icons/arrows-up.svg",
    'asterisk': STATIC_ASSET_URL + "/icons/asterisk.svg",
    'at-sign': STATIC_ASSET_URL + "/icons/at-sign.svg",
    'atom': STATIC_ASSET_URL + "/icons/atom.svg",
    'attachment': STATIC_ASSET_URL + "/icons/attachment.svg",
    'award-floral': STATIC_ASSET_URL + "/icons/award-floral.svg",
    'award': STATIC_ASSET_URL + "/icons/award.svg",
    'backpack': STATIC_ASSET_URL + "/icons/backpack.svg",
    'ban-cross': STATIC_ASSET_URL + "/icons/ban-cross.svg",
    'ban': STATIC_ASSET_URL + "/icons/ban.svg",
    'bank-note': STATIC_ASSET_URL + "/icons/bank-note.svg",
    'bank': STATIC_ASSET_URL + "/icons/bank.svg",
    'bar-chart-axis': STATIC_ASSET_URL + "/icons/bar-chart-axis.svg",
    'bar-chart-stack': STATIC_ASSET_URL + "/icons/bar-chart-stack.svg",
    'bar-chart': STATIC_ASSET_URL + "/icons/bar-chart.svg",
    'bar-line-chart': STATIC_ASSET_URL + "/icons/bar-line-chart.svg",
    'battery-charging': STATIC_ASSET_URL + "/icons/battery-charging.svg",
    'battery-empty': STATIC_ASSET_URL + "/icons/battery-empty.svg",
    'battery-full': STATIC_ASSET_URL + "/icons/battery-full.svg",
    'battery-low': STATIC_ASSET_URL + "/icons/battery-low.svg",
    'battery-mid': STATIC_ASSET_URL + "/icons/battery-mid.svg",
    'beaker': STATIC_ASSET_URL + "/icons/beaker.svg",
    'bell-minus': STATIC_ASSET_URL + "/icons/bell-minus.svg",
    'bell-off': STATIC_ASSET_URL + "/icons/bell-off.svg",
    'bell-plus': STATIC_ASSET_URL + "/icons/bell-plus.svg",
    'bell-ringing': STATIC_ASSET_URL + "/icons/bell-ringing.svg",
    'bell': STATIC_ASSET_URL + "/icons/bell.svg",
    'bezier-curve': STATIC_ASSET_URL + "/icons/bezier-curve.svg",
    'bluetooth-connect': STATIC_ASSET_URL + "/icons/bluetooth-connect.svg",
    'bluetooth-on': STATIC_ASSET_URL + "/icons/bluetooth-on.svg",
    'bluetooth-signal': STATIC_ASSET_URL + "/icons/bluetooth-signal.svg",
    'bluetooth': STATIC_ASSET_URL + "/icons/bluetooth.svg",
    'bold': STATIC_ASSET_URL + "/icons/bold.svg",
    'book-closed': STATIC_ASSET_URL + "/icons/book-closed.svg",
    'book-open': STATIC_ASSET_URL + "/icons/book-open.svg",
    'bookmark-add': STATIC_ASSET_URL + "/icons/bookmark-add.svg",
    'bookmark-check': STATIC_ASSET_URL + "/icons/bookmark-check.svg",
    'bookmark-minus': STATIC_ASSET_URL + "/icons/bookmark-minus.svg",
    'bookmark-x': STATIC_ASSET_URL + "/icons/bookmark-x.svg",
    'bookmark': STATIC_ASSET_URL + "/icons/bookmark.svg",
    'box': STATIC_ASSET_URL + "/icons/box.svg",
    'brackets-check': STATIC_ASSET_URL + "/icons/brackets-check.svg",
    'brackets-ellipses': STATIC_ASSET_URL + "/icons/brackets-ellipses.svg",
    'brackets-minus': STATIC_ASSET_URL + "/icons/brackets-minus.svg",
    'brackets-plus': STATIC_ASSET_URL + "/icons/brackets-plus.svg",
    'brackets-slash': STATIC_ASSET_URL + "/icons/brackets-slash.svg",
    'brackets-x': STATIC_ASSET_URL + "/icons/brackets-x.svg",
    'brackets': STATIC_ASSET_URL + "/icons/brackets.svg",
    'briefcase': STATIC_ASSET_URL + "/icons/briefcase.svg",
    'browser': STATIC_ASSET_URL + "/icons/browser.svg",
    'brush': STATIC_ASSET_URL + "/icons/brush.svg",
    'building-bank': STATIC_ASSET_URL + "/icons/building-bank.svg",
    'building-double-off': STATIC_ASSET_URL + "/icons/building-double-off.svg",
    'building-double': STATIC_ASSET_URL + "/icons/building-double.svg",
    'building-simple': STATIC_ASSET_URL + "/icons/building-simple.svg",
    'building-tripple': STATIC_ASSET_URL + "/icons/building-tripple.svg",
    'bus': STATIC_ASSET_URL + "/icons/bus.svg",
    'calculator': STATIC_ASSET_URL + "/icons/calculator.svg",
    'calendar-check': STATIC_ASSET_URL + "/icons/calendar-check.svg",
    'calendar-date': STATIC_ASSET_URL + "/icons/calendar-date.svg",
    'calendar-minus': STATIC_ASSET_URL + "/icons/calendar-minus.svg",
    'calendar-plus': STATIC_ASSET_URL + "/icons/calendar-plus.svg",
    'calendar': STATIC_ASSET_URL + "/icons/calendar.svg",
    'camera-lens': STATIC_ASSET_URL + "/icons/camera-lens.svg",
    'camera-off': STATIC_ASSET_URL + "/icons/camera-off.svg",
    'camera': STATIC_ASSET_URL + "/icons/camera.svg",
    'certificate': STATIC_ASSET_URL + "/icons/certificate.svg",
    'check-circle': STATIC_ASSET_URL + "/icons/check-circle.svg",
    'check-done': STATIC_ASSET_URL + "/icons/check-done.svg",
    'check': STATIC_ASSET_URL + "/icons/check.svg",
    'chevron-down-double': STATIC_ASSET_URL + "/icons/chevron-down-double.svg",
    'chevron-down': STATIC_ASSET_URL + "/icons/chevron-down.svg",
    'chevron-left-double': STATIC_ASSET_URL + "/icons/chevron-left-double.svg",
    'chevron-left': STATIC_ASSET_URL + "/icons/chevron-left.svg",
    'chevron-right-double': STATIC_ASSET_URL + "/icons/chevron-right-double.svg",
    'chevron-right': STATIC_ASSET_URL + "/icons/chevron-right.svg",
    'chevron-selector-horizontal': STATIC_ASSET_URL + "/icons/chevron-selector-horizontal.svg",
    'chevron-selector-vertical': STATIC_ASSET_URL + "/icons/chevron-selector-vertical.svg",
    'chevron-up-double': STATIC_ASSET_URL + "/icons/chevron-up-double.svg",
    'chevron-up': STATIC_ASSET_URL + "/icons/chevron-up.svg",
    'chrome-cast': STATIC_ASSET_URL + "/icons/chrome-cast.svg",
    'circle-cut': STATIC_ASSET_URL + "/icons/circle-cut.svg",
    'circle': STATIC_ASSET_URL + "/icons/circle.svg",
    'clapperboard': STATIC_ASSET_URL + "/icons/clapperboard.svg",
    'clipboard-attachment': STATIC_ASSET_URL + "/icons/clipboard-attachment.svg",
    'clipboard-check': STATIC_ASSET_URL + "/icons/clipboard-check.svg",
    'clipboard-download': STATIC_ASSET_URL + "/icons/clipboard-download.svg",
    'clipboard-minus': STATIC_ASSET_URL + "/icons/clipboard-minus.svg",
    'clipboard-plus': STATIC_ASSET_URL + "/icons/clipboard-plus.svg",
    'clipboard-x': STATIC_ASSET_URL + "/icons/clipboard-x.svg",
    'clipboard': STATIC_ASSET_URL + "/icons/clipboard.svg",
    'clock-check': STATIC_ASSET_URL + "/icons/clock-check.svg",
    'clock-fast-forward': STATIC_ASSET_URL + "/icons/clock-fast-forward.svg",
    'clock-plus': STATIC_ASSET_URL + "/icons/clock-plus.svg",
    'clock-refresh': STATIC_ASSET_URL + "/icons/clock-refresh.svg",
    'clock-rewind': STATIC_ASSET_URL + "/icons/clock-rewind.svg",
    'clock-snooze': STATIC_ASSET_URL + "/icons/clock-snooze.svg",
    'clock-stopwatch': STATIC_ASSET_URL + "/icons/clock-stopwatch.svg",
    'clock': STATIC_ASSET_URL + "/icons/clock.svg",
    'cloud-blank': STATIC_ASSET_URL + "/icons/cloud-blank.svg",
    'cloud-lightning': STATIC_ASSET_URL + "/icons/cloud-lightning.svg",
    'cloud-moon': STATIC_ASSET_URL + "/icons/cloud-moon.svg",
    'cloud-off': STATIC_ASSET_URL + "/icons/cloud-off.svg",
    'cloud-raining-diagonal': STATIC_ASSET_URL + "/icons/cloud-raining-diagonal.svg",
    'cloud-raining-drops': STATIC_ASSET_URL + "/icons/cloud-raining-drops.svg",
    'cloud-raining': STATIC_ASSET_URL + "/icons/cloud-raining.svg",
    'cloud-snowing': STATIC_ASSET_URL + "/icons/cloud-snowing.svg",
    'cloud-sun': STATIC_ASSET_URL + "/icons/cloud-sun.svg",
    'cloud': STATIC_ASSET_URL + "/icons/cloud.svg",
    'code-browser': STATIC_ASSET_URL + "/icons/code-browser.svg",
    'code-slash': STATIC_ASSET_URL + "/icons/code-slash.svg",
    'code-snippet': STATIC_ASSET_URL + "/icons/code-snippet.svg",
    'code': STATIC_ASSET_URL + "/icons/code.svg",
    'codepen': STATIC_ASSET_URL + "/icons/codepen.svg",
    'coins-hand': STATIC_ASSET_URL + "/icons/coins-hand.svg",
    'coins-stacked': STATIC_ASSET_URL + "/icons/coins-stacked.svg",
    'coins-swap': STATIC_ASSET_URL + "/icons/coins-swap.svg",
    'coins': STATIC_ASSET_URL + "/icons/coins.svg",
    'colors': STATIC_ASSET_URL + "/icons/colors.svg",
    'columns': STATIC_ASSET_URL + "/icons/columns.svg",
    'command': STATIC_ASSET_URL + "/icons/command.svg",
    'compass-direction': STATIC_ASSET_URL + "/icons/compass-direction.svg",
    'compass': STATIC_ASSET_URL + "/icons/compass.svg",
    'container': STATIC_ASSET_URL + "/icons/container.svg",
    'contrast': STATIC_ASSET_URL + "/icons/contrast.svg",
    'copy': STATIC_ASSET_URL + "/icons/copy.svg",
    'corner-down-left': STATIC_ASSET_URL + "/icons/corner-down-left.svg",
    'corner-down-right': STATIC_ASSET_URL + "/icons/corner-down-right.svg",
    'corner-left-down': STATIC_ASSET_URL + "/icons/corner-left-down.svg",
    'corner-left-up': STATIC_ASSET_URL + "/icons/corner-left-up.svg",
    'corner-right-down': STATIC_ASSET_URL + "/icons/corner-right-down.svg",
    'corner-right-up': STATIC_ASSET_URL + "/icons/corner-right-up.svg",
    'corner-up-left': STATIC_ASSET_URL + "/icons/corner-up-left.svg",
    'corner-up-right': STATIC_ASSET_URL + "/icons/corner-up-right.svg",
    'cpu-chip': STATIC_ASSET_URL + "/icons/cpu-chip.svg",
    'credit-card-check': STATIC_ASSET_URL + "/icons/credit-card-check.svg",
    'credit-card-down': STATIC_ASSET_URL + "/icons/credit-card-down.svg",
    'credit-card-download': STATIC_ASSET_URL + "/icons/credit-card-download.svg",
    'credit-card-edit': STATIC_ASSET_URL + "/icons/credit-card-edit.svg",
    'credit-card-lock': STATIC_ASSET_URL + "/icons/credit-card-lock.svg",
    'credit-card-minus': STATIC_ASSET_URL + "/icons/credit-card-minus.svg",
    'credit-card-plus': STATIC_ASSET_URL + "/icons/credit-card-plus.svg",
    'credit-card-refresh': STATIC_ASSET_URL + "/icons/credit-card-refresh.svg",
    'credit-card-search': STATIC_ASSET_URL + "/icons/credit-card-search.svg",
    'credit-card-shield': STATIC_ASSET_URL + "/icons/credit-card-shield.svg",
    'credit-card-up': STATIC_ASSET_URL + "/icons/credit-card-up.svg",
    'credit-card-upload': STATIC_ASSET_URL + "/icons/credit-card-upload.svg",
    'credit-card-x': STATIC_ASSET_URL + "/icons/credit-card-x.svg",
    'credit-card': STATIC_ASSET_URL + "/icons/credit-card.svg",
    'credit-in': STATIC_ASSET_URL + "/icons/credit-in.svg",
    'crop': STATIC_ASSET_URL + "/icons/crop.svg",
    'cryptocurrency': STATIC_ASSET_URL + "/icons/cryptocurrency.svg",
    'cube-outline': STATIC_ASSET_URL + "/icons/cube-outline.svg",
    'cube': STATIC_ASSET_URL + "/icons/cube.svg",
    'currency-bitcoin': STATIC_ASSET_URL + "/icons/currency-bitcoin.svg",
    'currency-dollar': STATIC_ASSET_URL + "/icons/currency-dollar.svg",
    'currency-ethereum': STATIC_ASSET_URL + "/icons/currency-ethereum.svg",
    'currency-euro': STATIC_ASSET_URL + "/icons/currency-euro.svg",
    'currency-pound': STATIC_ASSET_URL + "/icons/currency-pound.svg",
    'currency-ruble': STATIC_ASSET_URL + "/icons/currency-ruble.svg",
    'currency-rupee': STATIC_ASSET_URL + "/icons/currency-rupee.svg",
    'currency-yen': STATIC_ASSET_URL + "/icons/currency-yen.svg",
    'cursor-click': STATIC_ASSET_URL + "/icons/cursor-click.svg",
    'cursor': STATIC_ASSET_URL + "/icons/cursor.svg",
    'database': STATIC_ASSET_URL + "/icons/database.svg",
    'dataflow': STATIC_ASSET_URL + "/icons/dataflow.svg",
    'delete': STATIC_ASSET_URL + "/icons/delete.svg",
    'diamond': STATIC_ASSET_URL + "/icons/diamond.svg",
    'disc': STATIC_ASSET_URL + "/icons/disc.svg",
    'distribute-spacing-horizontal': STATIC_ASSET_URL + "/icons/distribute-spacing-horizontal.svg",
    'distribute-spacing-vertical': STATIC_ASSET_URL + "/icons/distribute-spacing-vertical.svg",
    'divide': STATIC_ASSET_URL + "/icons/divide.svg",
    'divider': STATIC_ASSET_URL + "/icons/divider.svg",
    'dotpoints': STATIC_ASSET_URL + "/icons/dotpoints.svg",
    'dots-grid': STATIC_ASSET_URL + "/icons/dots-grid.svg",
    'dots-horizontal': STATIC_ASSET_URL + "/icons/dots-horizontal.svg",
    'dots-vertical': STATIC_ASSET_URL + "/icons/dots-vertical.svg",
    'download-cloud': STATIC_ASSET_URL + "/icons/download-cloud.svg",
    'download': STATIC_ASSET_URL + "/icons/download.svg",
    'draft': STATIC_ASSET_URL + "/icons/draft.svg",
    'drag': STATIC_ASSET_URL + "/icons/drag.svg",
    'drop': STATIC_ASSET_URL + "/icons/drop.svg",
    'droplets': STATIC_ASSET_URL + "/icons/droplets.svg",
    'dropper': STATIC_ASSET_URL + "/icons/dropper.svg",
    'earth': STATIC_ASSET_URL + "/icons/earth.svg",
    'edit': STATIC_ASSET_URL + "/icons/edit.svg",
    'equal-not': STATIC_ASSET_URL + "/icons/equal-not.svg",
    'equal': STATIC_ASSET_URL + "/icons/equal.svg",
    'eraser': STATIC_ASSET_URL + "/icons/eraser.svg",
    'expand': STATIC_ASSET_URL + "/icons/expand.svg",
    'export': STATIC_ASSET_URL + "/icons/export.svg",
    'eye-off': STATIC_ASSET_URL + "/icons/eye-off.svg",
    'eye': STATIC_ASSET_URL + "/icons/eye.svg",
    'face-content': STATIC_ASSET_URL + "/icons/face-content.svg",
    'face-frown': STATIC_ASSET_URL + "/icons/face-frown.svg",
    'face-happy': STATIC_ASSET_URL + "/icons/face-happy.svg",
    'face-id-square': STATIC_ASSET_URL + "/icons/face-id-square.svg",
    'face-neutral': STATIC_ASSET_URL + "/icons/face-neutral.svg",
    'face-sad': STATIC_ASSET_URL + "/icons/face-sad.svg",
    'face-smile': STATIC_ASSET_URL + "/icons/face-smile.svg",
    'face-wink': STATIC_ASSET_URL + "/icons/face-wink.svg",
    'fast-backward': STATIC_ASSET_URL + "/icons/fast-backward.svg",
    'fast-forward': STATIC_ASSET_URL + "/icons/fast-forward.svg",
    'figma': STATIC_ASSET_URL + "/icons/figma.svg",
    'file-analytics': STATIC_ASSET_URL + "/icons/file-analytics.svg",
    'file-attachment-left': STATIC_ASSET_URL + "/icons/file-attachment-left.svg",
    'file-attachment-right': STATIC_ASSET_URL + "/icons/file-attachment-right.svg",
    'file-check': STATIC_ASSET_URL + "/icons/file-check.svg",
    'file-code': STATIC_ASSET_URL + "/icons/file-code.svg",
    'file-doc': STATIC_ASSET_URL + "/icons/file-doc.svg",
    'file-download': STATIC_ASSET_URL + "/icons/file-download.svg",
    'file-heart': STATIC_ASSET_URL + "/icons/file-heart.svg",
    'file-lock': STATIC_ASSET_URL + "/icons/file-lock.svg",
    'file-minus': STATIC_ASSET_URL + "/icons/file-minus.svg",
    'file-plus': STATIC_ASSET_URL + "/icons/file-plus.svg",
    'file-question': STATIC_ASSET_URL + "/icons/file-question.svg",
    'file-search': STATIC_ASSET_URL + "/icons/file-search.svg",
    'file-shield': STATIC_ASSET_URL + "/icons/file-shield.svg",
    'file-x': STATIC_ASSET_URL + "/icons/file-x.svg",
    'file': STATIC_ASSET_URL + "/icons/file.svg",
    'film': STATIC_ASSET_URL + "/icons/film.svg",
    'filter-funnel': STATIC_ASSET_URL + "/icons/filter-funnel.svg",
    'fingerprint': STATIC_ASSET_URL + "/icons/fingerprint.svg",
    'flag': STATIC_ASSET_URL + "/icons/flag.svg",
    'flash-off': STATIC_ASSET_URL + "/icons/flash-off.svg",
    'flash': STATIC_ASSET_URL + "/icons/flash.svg",
    'flex-align-bottom': STATIC_ASSET_URL + "/icons/flex-align-bottom.svg",
    'flex-align-left': STATIC_ASSET_URL + "/icons/flex-align-left.svg",
    'flex-align-right': STATIC_ASSET_URL + "/icons/flex-align-right.svg",
    'flex-align-top': STATIC_ASSET_URL + "/icons/flex-align-top.svg",
    'fold-left': STATIC_ASSET_URL + "/icons/fold-left.svg",
    'fold-right': STATIC_ASSET_URL + "/icons/fold-right.svg",
    'folder-check': STATIC_ASSET_URL + "/icons/folder-check.svg",
    'folder-closed': STATIC_ASSET_URL + "/icons/folder-closed.svg",
    'folder-code': STATIC_ASSET_URL + "/icons/folder-code.svg",
    'folder-download': STATIC_ASSET_URL + "/icons/folder-download.svg",
    'folder-lock': STATIC_ASSET_URL + "/icons/folder-lock.svg",
    'folder-minus': STATIC_ASSET_URL + "/icons/folder-minus.svg",
    'folder-move': STATIC_ASSET_URL + "/icons/folder-move.svg",
    'folder-plus': STATIC_ASSET_URL + "/icons/folder-plus.svg",
    'folder-question': STATIC_ASSET_URL + "/icons/folder-question.svg",
    'folder-search': STATIC_ASSET_URL + "/icons/folder-search.svg",
    'folder-shield': STATIC_ASSET_URL + "/icons/folder-shield.svg",
    'folder-x': STATIC_ASSET_URL + "/icons/folder-x.svg",
    'folder': STATIC_ASSET_URL + "/icons/folder.svg",
    'gaming-pad': STATIC_ASSET_URL + "/icons/gaming-pad.svg",
    'gift': STATIC_ASSET_URL + "/icons/gift.svg",
    'git-branch': STATIC_ASSET_URL + "/icons/git-branch.svg",
    'git-commit': STATIC_ASSET_URL + "/icons/git-commit.svg",
    'git-merge': STATIC_ASSET_URL + "/icons/git-merge.svg",
    'git-pull-request': STATIC_ASSET_URL + "/icons/git-pull-request.svg",
    'glasses': STATIC_ASSET_URL + "/icons/glasses.svg",
    'globe-stand': STATIC_ASSET_URL + "/icons/globe-stand.svg",
    'globe': STATIC_ASSET_URL + "/icons/globe.svg",
    'google-chrome': STATIC_ASSET_URL + "/icons/google-chrome.svg",
    'graduation-hat': STATIC_ASSET_URL + "/icons/graduation-hat.svg",
    'grid': STATIC_ASSET_URL + "/icons/grid.svg",
    'hand': STATIC_ASSET_URL + "/icons/hand.svg",
    'hash': STATIC_ASSET_URL + "/icons/hash.svg",
    'heading': STATIC_ASSET_URL + "/icons/heading.svg",
    'headphones': STATIC_ASSET_URL + "/icons/headphones.svg",
    'heart-circle': STATIC_ASSET_URL + "/icons/heart-circle.svg",
    'heart-hand': STATIC_ASSET_URL + "/icons/heart-hand.svg",
    'heart-rounded': STATIC_ASSET_URL + "/icons/heart-rounded.svg",
    'heart': STATIC_ASSET_URL + "/icons/heart.svg",
    'hearts': STATIC_ASSET_URL + "/icons/hearts.svg",
    'help-circle': STATIC_ASSET_URL + "/icons/help-circle.svg",
    'hexagon': STATIC_ASSET_URL + "/icons/hexagon.svg",
    'home': STATIC_ASSET_URL + "/icons/home.svg",
    'horizontal-bar-chart': STATIC_ASSET_URL + "/icons/horizontal-bar-chart.svg",
    'hourglass': STATIC_ASSET_URL + "/icons/hourglass.svg",
    'html5': STATIC_ASSET_URL + "/icons/html5.svg",
    'hurricane': STATIC_ASSET_URL + "/icons/hurricane.svg",
    'image-check': STATIC_ASSET_URL + "/icons/image-check.svg",
    'image-down': STATIC_ASSET_URL + "/icons/image-down.svg",
    'image-indent-left': STATIC_ASSET_URL + "/icons/image-indent-left.svg",
    'image-indent-right': STATIC_ASSET_URL + "/icons/image-indent-right.svg",
    'image-left': STATIC_ASSET_URL + "/icons/image-left.svg",
    'image-plus': STATIC_ASSET_URL + "/icons/image-plus.svg",
    'image-right': STATIC_ASSET_URL + "/icons/image-right.svg",
    'image-up': STATIC_ASSET_URL + "/icons/image-up.svg",
    'image-user-check': STATIC_ASSET_URL + "/icons/image-user-check.svg",
    'image-user-down': STATIC_ASSET_URL + "/icons/image-user-down.svg",
    'image-user-left': STATIC_ASSET_URL + "/icons/image-user-left.svg",
    'image-user-plus': STATIC_ASSET_URL + "/icons/image-user-plus.svg",
    'image-user-right': STATIC_ASSET_URL + "/icons/image-user-right.svg",
    'image-user-up': STATIC_ASSET_URL + "/icons/image-user-up.svg",
    'image-user-x': STATIC_ASSET_URL + "/icons/image-user-x.svg",
    'image-user': STATIC_ASSET_URL + "/icons/image-user.svg",
    'image-x': STATIC_ASSET_URL + "/icons/image-x.svg",
    'image': STATIC_ASSET_URL + "/icons/image.svg",
    'inbox': STATIC_ASSET_URL + "/icons/inbox.svg",
    'infinity': STATIC_ASSET_URL + "/icons/infinity.svg",
    'info-circle': STATIC_ASSET_URL + "/icons/info-circle.svg",
    'intersect-square': STATIC_ASSET_URL + "/icons/intersect-square.svg",
    'italic': STATIC_ASSET_URL + "/icons/italic.svg",
    'key': STATIC_ASSET_URL + "/icons/key.svg",
    'keyboard': STATIC_ASSET_URL + "/icons/keyboard.svg",
    'laptop': STATIC_ASSET_URL + "/icons/laptop.svg",
    'layer-single': STATIC_ASSET_URL + "/icons/layer-single.svg",
    'layers-three': STATIC_ASSET_URL + "/icons/layers-three.svg",
    'layout-bottom': STATIC_ASSET_URL + "/icons/layout-bottom.svg",
    'layout-left': STATIC_ASSET_URL + "/icons/layout-left.svg",
    'layout-right': STATIC_ASSET_URL + "/icons/layout-right.svg",
    'layout-top': STATIC_ASSET_URL + "/icons/layout-top.svg",
    'layout': STATIC_ASSET_URL + "/icons/layout.svg",
    'left-indent': STATIC_ASSET_URL + "/icons/left-indent.svg",
    'letter-spacing': STATIC_ASSET_URL + "/icons/letter-spacing.svg",
    'life-buoy': STATIC_ASSET_URL + "/icons/life-buoy.svg",
    'lightbulb': STATIC_ASSET_URL + "/icons/lightbulb.svg",
    'lightning': STATIC_ASSET_URL + "/icons/lightning.svg",
    'line-chart-down': STATIC_ASSET_URL + "/icons/line-chart-down.svg",
    'line-chart-up': STATIC_ASSET_URL + "/icons/line-chart-up.svg",
    'line-height': STATIC_ASSET_URL + "/icons/line-height.svg",
    'link-broken': STATIC_ASSET_URL + "/icons/link-broken.svg",
    'link-external': STATIC_ASSET_URL + "/icons/link-external.svg",
    'link': STATIC_ASSET_URL + "/icons/link.svg",
    'list': STATIC_ASSET_URL + "/icons/list.svg",
    'loading': STATIC_ASSET_URL + "/icons/loading.svg",
    'lock-keyhole-circle': STATIC_ASSET_URL + "/icons/lock-keyhole-circle.svg",
    'lock-unlocked': STATIC_ASSET_URL + "/icons/lock-unlocked.svg",
    'lock': STATIC_ASSET_URL + "/icons/lock.svg",
    'log-in': STATIC_ASSET_URL + "/icons/log-in.svg",
    'log-out': STATIC_ASSET_URL + "/icons/log-out.svg",
    'magic-wand': STATIC_ASSET_URL + "/icons/magic-wand.svg",
    'mail-off': STATIC_ASSET_URL + "/icons/mail-off.svg",
    'mail-open': STATIC_ASSET_URL + "/icons/mail-open.svg",
    'mail': STATIC_ASSET_URL + "/icons/mail.svg",
    'map': STATIC_ASSET_URL + "/icons/map.svg",
    'mark': STATIC_ASSET_URL + "/icons/mark.svg",
    'marker-flag': STATIC_ASSET_URL + "/icons/marker-flag.svg",
    'marker-pin-radius': STATIC_ASSET_URL + "/icons/marker-pin-radius.svg",
    'marker-pin': STATIC_ASSET_URL + "/icons/marker-pin.svg",
    'maximize': STATIC_ASSET_URL + "/icons/maximize.svg",
    'medal': STATIC_ASSET_URL + "/icons/medal.svg",
    'medical-cross': STATIC_ASSET_URL + "/icons/medical-cross.svg",
    'menu': STATIC_ASSET_URL + "/icons/menu.svg",
    'message-alert-circle': STATIC_ASSET_URL + "/icons/message-alert-circle.svg",
    'message-chat-circle': STATIC_ASSET_URL + "/icons/message-chat-circle.svg",
    'message-check-circle': STATIC_ASSET_URL + "/icons/message-check-circle.svg",
    'message-circle': STATIC_ASSET_URL + "/icons/message-circle.svg",
    'message-dots-circle': STATIC_ASSET_URL + "/icons/message-dots-circle.svg",
    'message-heart-circle': STATIC_ASSET_URL + "/icons/message-heart-circle.svg",
    'message-notification-circle': STATIC_ASSET_URL + "/icons/message-notification-circle.svg",
    'message-notification-square': STATIC_ASSET_URL + "/icons/message-notification-square.svg",
    'message-plus-circle': STATIC_ASSET_URL + "/icons/message-plus-circle.svg",
    'message-question-circle': STATIC_ASSET_URL + "/icons/message-question-circle.svg",
    'message-smile-circle': STATIC_ASSET_URL + "/icons/message-smile-circle.svg",
    'message-text-circle': STATIC_ASSET_URL + "/icons/message-text-circle.svg",
    'message-x-circle': STATIC_ASSET_URL + "/icons/message-x-circle.svg",
    'microphone-off': STATIC_ASSET_URL + "/icons/microphone-off.svg",
    'microphone': STATIC_ASSET_URL + "/icons/microphone.svg",
    'microscope': STATIC_ASSET_URL + "/icons/microscope.svg",
    'minimize': STATIC_ASSET_URL + "/icons/minimize.svg",
    'minus-circle': STATIC_ASSET_URL + "/icons/minus-circle.svg",
    'minus-square': STATIC_ASSET_URL + "/icons/minus-square.svg",
    'minus': STATIC_ASSET_URL + "/icons/minus.svg",
    'mobile': STATIC_ASSET_URL + "/icons/mobile.svg",
    'modem': STATIC_ASSET_URL + "/icons/modem.svg",
    'monitor': STATIC_ASSET_URL + "/icons/monitor.svg",
    'moon-eclipse': STATIC_ASSET_URL + "/icons/moon-eclipse.svg",
    'moon-star': STATIC_ASSET_URL + "/icons/moon-star.svg",
    'moon': STATIC_ASSET_URL + "/icons/moon.svg",
    'mouse': STATIC_ASSET_URL + "/icons/mouse.svg",
    'move': STATIC_ASSET_URL + "/icons/move.svg",
    'music-note-beam': STATIC_ASSET_URL + "/icons/music-note-beam.svg",
    'music-note-quaver-plus': STATIC_ASSET_URL + "/icons/music-note-quaver-plus.svg",
    'music-note-quaver': STATIC_ASSET_URL + "/icons/music-note-quaver.svg",
    'nav-audience-workflow': STATIC_ASSET_URL + "/icons/nav-audience-workflow.svg",
    'nav-data-workflow': STATIC_ASSET_URL + "/icons/nav-data-workflow.svg",
    'navigation-pointer-off': STATIC_ASSET_URL + "/icons/navigation-pointer-off.svg",
    'navigation-pointer': STATIC_ASSET_URL + "/icons/navigation-pointer.svg",
    'notification-box': STATIC_ASSET_URL + "/icons/notification-box.svg",
    'notification-text': STATIC_ASSET_URL + "/icons/notification-text.svg",
    'octagon': STATIC_ASSET_URL + "/icons/octagon.svg",
    'package-check': STATIC_ASSET_URL + "/icons/package-check.svg",
    'package-minus': STATIC_ASSET_URL + "/icons/package-minus.svg",
    'package-plus': STATIC_ASSET_URL + "/icons/package-plus.svg",
    'package-search': STATIC_ASSET_URL + "/icons/package-search.svg",
    'package-x': STATIC_ASSET_URL + "/icons/package-x.svg",
    'package': STATIC_ASSET_URL + "/icons/package.svg",
    'paint-pour': STATIC_ASSET_URL + "/icons/paint-pour.svg",
    'palette': STATIC_ASSET_URL + "/icons/palette.svg",
    'paperclip': STATIC_ASSET_URL + "/icons/paperclip.svg",
    'paragraph-spacing': STATIC_ASSET_URL + "/icons/paragraph-spacing.svg",
    'paragraph-wrap': STATIC_ASSET_URL + "/icons/paragraph-wrap.svg",
    'passcode-lock': STATIC_ASSET_URL + "/icons/passcode-lock.svg",
    'passcode': STATIC_ASSET_URL + "/icons/passcode.svg",
    'passport': STATIC_ASSET_URL + "/icons/passport.svg",
    'pause-circle': STATIC_ASSET_URL + "/icons/pause-circle.svg",
    'pause-square': STATIC_ASSET_URL + "/icons/pause-square.svg",
    'pen-tool-minus': STATIC_ASSET_URL + "/icons/pen-tool-minus.svg",
    'pen-tool-plus': STATIC_ASSET_URL + "/icons/pen-tool-plus.svg",
    'pen-tool': STATIC_ASSET_URL + "/icons/pen-tool.svg",
    'pencil-line': STATIC_ASSET_URL + "/icons/pencil-line.svg",
    'pencil': STATIC_ASSET_URL + "/icons/pencil.svg",
    'pentagon': STATIC_ASSET_URL + "/icons/pentagon.svg",
    'percent': STATIC_ASSET_URL + "/icons/percent.svg",
    'perspective': STATIC_ASSET_URL + "/icons/perspective.svg",
    'phone-call': STATIC_ASSET_URL + "/icons/phone-call.svg",
    'phone-hang-up': STATIC_ASSET_URL + "/icons/phone-hang-up.svg",
    'phone-incoming': STATIC_ASSET_URL + "/icons/phone-incoming.svg",
    'phone-outgoing': STATIC_ASSET_URL + "/icons/phone-outgoing.svg",
    'phone-pause': STATIC_ASSET_URL + "/icons/phone-pause.svg",
    'phone-plus': STATIC_ASSET_URL + "/icons/phone-plus.svg",
    'phone-x': STATIC_ASSET_URL + "/icons/phone-x.svg",
    'phone': STATIC_ASSET_URL + "/icons/phone.svg",
    'pie-chart-dense': STATIC_ASSET_URL + "/icons/pie-chart-dense.svg",
    'pie-chart': STATIC_ASSET_URL + "/icons/pie-chart.svg",
    'piggy-bank': STATIC_ASSET_URL + "/icons/piggy-bank.svg",
    'pilcrow': STATIC_ASSET_URL + "/icons/pilcrow.svg",
    'pin': STATIC_ASSET_URL + "/icons/pin.svg",
    'placeholder': STATIC_ASSET_URL + "/icons/placeholder.svg",
    'play': STATIC_ASSET_URL + "/icons/play.svg",
    'plus-square': STATIC_ASSET_URL + "/icons/plus-square.svg",
    'plus': STATIC_ASSET_URL + "/icons/plus.svg",
    'podcast': STATIC_ASSET_URL + "/icons/podcast.svg",
    'power': STATIC_ASSET_URL + "/icons/power.svg",
    'preferences': STATIC_ASSET_URL + "/icons/preferences.svg",
    'presentation-chart': STATIC_ASSET_URL + "/icons/presentation-chart.svg",
    'printer': STATIC_ASSET_URL + "/icons/printer.svg",
    'puzzle-piece': STATIC_ASSET_URL + "/icons/puzzle-piece.svg",
    'qr-code-dense': STATIC_ASSET_URL + "/icons/qr-code-dense.svg",
    'qr-code': STATIC_ASSET_URL + "/icons/qr-code.svg",
    'receipt-check': STATIC_ASSET_URL + "/icons/receipt-check.svg",
    'receipt': STATIC_ASSET_URL + "/icons/receipt.svg",
    'recording': STATIC_ASSET_URL + "/icons/recording.svg",
    'reflect': STATIC_ASSET_URL + "/icons/reflect.svg",
    'refresh-cw': STATIC_ASSET_URL + "/icons/refresh-cw.svg",
    'repeat': STATIC_ASSET_URL + "/icons/repeat.svg",
    'report-external': STATIC_ASSET_URL + "/icons/report-external.svg",
    'right-indent-middle': STATIC_ASSET_URL + "/icons/right-indent-middle.svg",
    'right-indent': STATIC_ASSET_URL + "/icons/right-indent.svg",
    'robot': STATIC_ASSET_URL + "/icons/robot.svg",
    'rocket': STATIC_ASSET_URL + "/icons/rocket.svg",
    'roller-brush': STATIC_ASSET_URL + "/icons/roller-brush.svg",
    'route': STATIC_ASSET_URL + "/icons/route.svg",
    'rows': STATIC_ASSET_URL + "/icons/rows.svg",
    'rss': STATIC_ASSET_URL + "/icons/rss.svg",
    'ruler': STATIC_ASSET_URL + "/icons/ruler.svg",
    'safe': STATIC_ASSET_URL + "/icons/safe.svg",
    'sale': STATIC_ASSET_URL + "/icons/sale.svg",
    'save': STATIC_ASSET_URL + "/icons/save.svg",
    'scale-down': STATIC_ASSET_URL + "/icons/scale-down.svg",
    'scale-up': STATIC_ASSET_URL + "/icons/scale-up.svg",
    'scales': STATIC_ASSET_URL + "/icons/scales.svg",
    'scan': STATIC_ASSET_URL + "/icons/scan.svg",
    'scissors': STATIC_ASSET_URL + "/icons/scissors.svg",
    'search-sm': STATIC_ASSET_URL + "/icons/search-sm.svg",
    'send-right': STATIC_ASSET_URL + "/icons/send-right.svg",
    'send-up': STATIC_ASSET_URL + "/icons/send-up.svg",
    'send': STATIC_ASSET_URL + "/icons/send.svg",
    'server-connect': STATIC_ASSET_URL + "/icons/server-connect.svg",
    'server-connected': STATIC_ASSET_URL + "/icons/server-connected.svg",
    'server-disc': STATIC_ASSET_URL + "/icons/server-disc.svg",
    'server-stack-disc': STATIC_ASSET_URL + "/icons/server-stack-disc.svg",
    'server-stack': STATIC_ASSET_URL + "/icons/server-stack.svg",
    'server': STATIC_ASSET_URL + "/icons/server.svg",
    'settings': STATIC_ASSET_URL + "/icons/settings.svg",
    'share-arrow': STATIC_ASSET_URL + "/icons/share-arrow.svg",
    'share': STATIC_ASSET_URL + "/icons/share.svg",
    'shield-dollar': STATIC_ASSET_URL + "/icons/shield-dollar.svg",
    'shield-empty': STATIC_ASSET_URL + "/icons/shield-empty.svg",
    'shield-off': STATIC_ASSET_URL + "/icons/shield-off.svg",
    'shield-plus': STATIC_ASSET_URL + "/icons/shield-plus.svg",
    'shield-tick': STATIC_ASSET_URL + "/icons/shield-tick.svg",
    'shield-zap': STATIC_ASSET_URL + "/icons/shield-zap.svg",
    'shield': STATIC_ASSET_URL + "/icons/shield.svg",
    'shop': STATIC_ASSET_URL + "/icons/shop.svg",
    'shopping-bag': STATIC_ASSET_URL + "/icons/shopping-bag.svg",
    'shopping-cart': STATIC_ASSET_URL + "/icons/shopping-cart.svg",
    'shuffle': STATIC_ASSET_URL + "/icons/shuffle.svg",
    'signal': STATIC_ASSET_URL + "/icons/signal.svg",
    'simcard': STATIC_ASSET_URL + "/icons/simcard.svg",
    'skew': STATIC_ASSET_URL + "/icons/skew.svg",
    'skip-back': STATIC_ASSET_URL + "/icons/skip-back.svg",
    'skip-forward': STATIC_ASSET_URL + "/icons/skip-forward.svg",
    'slash-divider': STATIC_ASSET_URL + "/icons/slash-divider.svg",
    'slash-octagon': STATIC_ASSET_URL + "/icons/slash-octagon.svg",
    'sliders': STATIC_ASSET_URL + "/icons/sliders.svg",
    'snowflake': STATIC_ASSET_URL + "/icons/snowflake.svg",
    'sort-ascending': STATIC_ASSET_URL + "/icons/sort-ascending.svg",
    'sort-atoz': STATIC_ASSET_URL + "/icons/sort-atoz.svg",
    'sort-descending': STATIC_ASSET_URL + "/icons/sort-descending.svg",
    'sort-ztoa': STATIC_ASSET_URL + "/icons/sort-ztoa.svg",
    'spacing-height': STATIC_ASSET_URL + "/icons/spacing-height.svg",
    'spacing-width': STATIC_ASSET_URL + "/icons/spacing-width.svg",
    'speaker': STATIC_ASSET_URL + "/icons/speaker.svg",
    'speedometer': STATIC_ASSET_URL + "/icons/speedometer.svg",
    'spreadsheet-upload': STATIC_ASSET_URL + "/icons/spreadsheet-upload.svg",
    'spreadsheet': STATIC_ASSET_URL + "/icons/spreadsheet.svg",
    'square': STATIC_ASSET_URL + "/icons/square.svg",
    'stand': STATIC_ASSET_URL + "/icons/stand.svg",
    'star-cluster': STATIC_ASSET_URL + "/icons/star-cluster.svg",
    'star-twinkle': STATIC_ASSET_URL + "/icons/star-twinkle.svg",
    'star': STATIC_ASSET_URL + "/icons/star.svg",
    'stars': STATIC_ASSET_URL + "/icons/stars.svg",
    'sticker-square': STATIC_ASSET_URL + "/icons/sticker-square.svg",
    'stop': STATIC_ASSET_URL + "/icons/stop.svg",
    'strikethrough': STATIC_ASSET_URL + "/icons/strikethrough.svg",
    'subscript': STATIC_ASSET_URL + "/icons/subscript.svg",
    'sun': STATIC_ASSET_URL + "/icons/sun.svg",
    'sunrise': STATIC_ASSET_URL + "/icons/sunrise.svg",
    'sunset': STATIC_ASSET_URL + "/icons/sunset.svg",
    'switch-down': STATIC_ASSET_URL + "/icons/switch-down.svg",
    'switch-left': STATIC_ASSET_URL + "/icons/switch-left.svg",
    'switch-right': STATIC_ASSET_URL + "/icons/switch-right.svg",
    'switch-up': STATIC_ASSET_URL + "/icons/switch-up.svg",
    'sync': STATIC_ASSET_URL + "/icons/sync.svg",
    'table': STATIC_ASSET_URL + "/icons/table.svg",
    'tablet': STATIC_ASSET_URL + "/icons/tablet.svg",
    'tag': STATIC_ASSET_URL + "/icons/tag.svg",
    'target-aim': STATIC_ASSET_URL + "/icons/target-aim.svg",
    'target-arrow': STATIC_ASSET_URL + "/icons/target-arrow.svg",
    'target-bullet': STATIC_ASSET_URL + "/icons/target-bullet.svg",
    'target-simple': STATIC_ASSET_URL + "/icons/target-simple.svg",
    'target': STATIC_ASSET_URL + "/icons/target.svg",
    'telescope': STATIC_ASSET_URL + "/icons/telescope.svg",
    'terminal-browser': STATIC_ASSET_URL + "/icons/terminal-browser.svg",
    'terminal-circle': STATIC_ASSET_URL + "/icons/terminal-circle.svg",
    'terminal-square': STATIC_ASSET_URL + "/icons/terminal-square.svg",
    'terminal': STATIC_ASSET_URL + "/icons/terminal.svg",
    'text-input': STATIC_ASSET_URL + "/icons/text-input.svg",
    'thermometer-cold': STATIC_ASSET_URL + "/icons/thermometer-cold.svg",
    'thermometer-scale': STATIC_ASSET_URL + "/icons/thermometer-scale.svg",
    'thermometer-warm': STATIC_ASSET_URL + "/icons/thermometer-warm.svg",
    'thermometer': STATIC_ASSET_URL + "/icons/thermometer.svg",
    'thumbs-down': STATIC_ASSET_URL + "/icons/thumbs-down.svg",
    'thumbs-up': STATIC_ASSET_URL + "/icons/thumbs-up.svg",
    'ticket': STATIC_ASSET_URL + "/icons/ticket.svg",
    'toggle-left': STATIC_ASSET_URL + "/icons/toggle-left.svg",
    'toggle-right': STATIC_ASSET_URL + "/icons/toggle-right.svg",
    'tool-set': STATIC_ASSET_URL + "/icons/tool-set.svg",
    'tool': STATIC_ASSET_URL + "/icons/tool.svg",
    'train': STATIC_ASSET_URL + "/icons/train.svg",
    'transform': STATIC_ASSET_URL + "/icons/transform.svg",
    'translate': STATIC_ASSET_URL + "/icons/translate.svg",
    'trash': STATIC_ASSET_URL + "/icons/trash.svg",
    'trend-down': STATIC_ASSET_URL + "/icons/trend-down.svg",
    'trend-up': STATIC_ASSET_URL + "/icons/trend-up.svg",
    'triangle': STATIC_ASSET_URL + "/icons/triangle.svg",
    'trophy': STATIC_ASSET_URL + "/icons/trophy.svg",
    'truck': STATIC_ASSET_URL + "/icons/truck.svg",
    'tv': STATIC_ASSET_URL + "/icons/tv.svg",
    'type-strikethrough': STATIC_ASSET_URL + "/icons/type-strikethrough.svg",
    'type': STATIC_ASSET_URL + "/icons/type.svg",
    'umbrella-beach': STATIC_ASSET_URL + "/icons/umbrella-beach.svg",
    'umbrella': STATIC_ASSET_URL + "/icons/umbrella.svg",
    'underline': STATIC_ASSET_URL + "/icons/underline.svg",
    'unsorted-folder': STATIC_ASSET_URL + "/icons/unsorted-folder.svg",
    'unsorted': STATIC_ASSET_URL + "/icons/unsorted.svg",
    'upload-cloud': STATIC_ASSET_URL + "/icons/upload-cloud.svg",
    'upload': STATIC_ASSET_URL + "/icons/upload.svg",
    'usb-flash-drive': STATIC_ASSET_URL + "/icons/usb-flash-drive.svg",
    'user-check': STATIC_ASSET_URL + "/icons/user-check.svg",
    'user-circle': STATIC_ASSET_URL + "/icons/user-circle.svg",
    'user-down-arrow': STATIC_ASSET_URL + "/icons/user-down-arrow.svg",
    'user-edit': STATIC_ASSET_URL + "/icons/user-edit.svg",
    'user-left-arrow': STATIC_ASSET_URL + "/icons/user-left-arrow.svg",
    'user-minus': STATIC_ASSET_URL + "/icons/user-minus.svg",
    'user-plus': STATIC_ASSET_URL + "/icons/user-plus.svg",
    'user-right-arrow': STATIC_ASSET_URL + "/icons/user-right-arrow.svg",
    'user-square': STATIC_ASSET_URL + "/icons/user-square.svg",
    'user-up-arrow': STATIC_ASSET_URL + "/icons/user-up-arrow.svg",
    'user-x': STATIC_ASSET_URL + "/icons/user-x.svg",
    'user': STATIC_ASSET_URL + "/icons/user.svg",
    'users-check': STATIC_ASSET_URL + "/icons/users-check.svg",
    'users-down-arrow': STATIC_ASSET_URL + "/icons/users-down-arrow.svg",
    'users-edit': STATIC_ASSET_URL + "/icons/users-edit.svg",
    'users-left-arrow': STATIC_ASSET_URL + "/icons/users-left-arrow.svg",
    'users-minus': STATIC_ASSET_URL + "/icons/users-minus.svg",
    'users-plus': STATIC_ASSET_URL + "/icons/users-plus.svg",
    'users-right-arrow': STATIC_ASSET_URL + "/icons/users-right-arrow.svg",
    'users-up-arrow': STATIC_ASSET_URL + "/icons/users-up-arrow.svg",
    'users-x': STATIC_ASSET_URL + "/icons/users-x.svg",
    'users': STATIC_ASSET_URL + "/icons/users.svg",
    'variable': STATIC_ASSET_URL + "/icons/variable.svg",
    'video-recorder-off': STATIC_ASSET_URL + "/icons/video-recorder-off.svg",
    'video-recorder': STATIC_ASSET_URL + "/icons/video-recorder.svg",
    'virus': STATIC_ASSET_URL + "/icons/virus.svg",
    'voicemail': STATIC_ASSET_URL + "/icons/voicemail.svg",
    'volume-minus': STATIC_ASSET_URL + "/icons/volume-minus.svg",
    'volume-plus': STATIC_ASSET_URL + "/icons/volume-plus.svg",
    'volume-x': STATIC_ASSET_URL + "/icons/volume-x.svg",
    'wallet': STATIC_ASSET_URL + "/icons/wallet.svg",
    'watch-circle': STATIC_ASSET_URL + "/icons/watch-circle.svg",
    'waves': STATIC_ASSET_URL + "/icons/waves.svg",
    'webcam': STATIC_ASSET_URL + "/icons/webcam.svg",
    'wifi-off': STATIC_ASSET_URL + "/icons/wifi-off.svg",
    'wifi': STATIC_ASSET_URL + "/icons/wifi.svg",
    'wind': STATIC_ASSET_URL + "/icons/wind.svg",
    'x-circle': STATIC_ASSET_URL + "/icons/x-circle.svg",
    'x-close': STATIC_ASSET_URL + "/icons/x-close.svg",
    'youtube': STATIC_ASSET_URL + "/icons/youtube.svg",
    'zap-fast': STATIC_ASSET_URL + "/icons/zap-fast.svg",
    'zap-off': STATIC_ASSET_URL + "/icons/zap-off.svg",
    'zap': STATIC_ASSET_URL + "/icons/zap.svg",
    'zip': STATIC_ASSET_URL + "/icons/zip.svg",
    'zoom-in': STATIC_ASSET_URL + "/icons/zoom-in.svg",
    'zoom-out': STATIC_ASSET_URL + "/icons/zoom-out.svg",
};
exports.PrimaryIllustrationAsset = {
    '404': STATIC_ASSET_URL + "/illustrations/primary/404.svg",
    'add-campaign': STATIC_ASSET_URL + "/illustrations/primary/add-campaign.svg",
    'apply-filter': STATIC_ASSET_URL + "/illustrations/primary/apply-filter.svg",
    'failure': STATIC_ASSET_URL + "/illustrations/primary/failure.svg",
    'no-data': STATIC_ASSET_URL + "/illustrations/primary/no-data.svg",
    'no-search-results': STATIC_ASSET_URL + "/illustrations/primary/no-search-results.svg",
    'progress': STATIC_ASSET_URL + "/illustrations/primary/progress.svg",
    'successful': STATIC_ASSET_URL + "/illustrations/primary/successful.svg",
    'under-maintenance': STATIC_ASSET_URL + "/illustrations/primary/under-maintenance.svg",
};
exports.SecondaryIllustrationAsset = {
    'alert': STATIC_ASSET_URL + "/illustrations/secondary/non-actionable/alert.svg",
    'file': STATIC_ASSET_URL + "/illustrations/secondary/non-actionable/file.svg",
    'no-data': STATIC_ASSET_URL + "/illustrations/secondary/non-actionable/no-data.svg",
    'no-search-result': STATIC_ASSET_URL + "/illustrations/secondary/non-actionable/no-search-result.svg",
};
exports.ActionableSecondaryIllustrationAsset = {
    'alert': STATIC_ASSET_URL + "/illustrations/secondary/actionable/alert.svg",
    'file': STATIC_ASSET_URL + "/illustrations/secondary/actionable/file.svg",
    'no-data': STATIC_ASSET_URL + "/illustrations/secondary/actionable/no-data.svg",
    'no-search-result': STATIC_ASSET_URL + "/illustrations/secondary/actionable/no-search-result.svg",
};
exports.AvatarCompanyLogoAsset = {
    '6sense-dark': STATIC_ASSET_URL + "/avatar-company-logos/6sense-dark.svg",
    '6sense-light': STATIC_ASSET_URL + "/avatar-company-logos/6sense-light.svg",
    'facebook': STATIC_ASSET_URL + "/avatar-company-logos/facebook.svg",
    'g2': STATIC_ASSET_URL + "/avatar-company-logos/g2.svg",
    'google-ads': STATIC_ASSET_URL + "/avatar-company-logos/google-ads.svg",
    'google': STATIC_ASSET_URL + "/avatar-company-logos/google.svg",
    'hubspot': STATIC_ASSET_URL + "/avatar-company-logos/hubspot.svg",
    'linkedin': STATIC_ASSET_URL + "/avatar-company-logos/linkedin.svg",
    'marketo': STATIC_ASSET_URL + "/avatar-company-logos/marketo.svg",
    'meta': STATIC_ASSET_URL + "/avatar-company-logos/meta.svg",
    'salesforce': STATIC_ASSET_URL + "/avatar-company-logos/salesforce.svg",
    'saleswhale': STATIC_ASSET_URL + "/avatar-company-logos/saleswhale.svg",
    'trustradius': STATIC_ASSET_URL + "/avatar-company-logos/trustradius.svg",
};
exports.SocialIconAsset = {
    'AngelList': STATIC_ASSET_URL + "/social-icons/AngelList.svg",
    'Apple': STATIC_ASSET_URL + "/social-icons/Apple.svg",
    'Clubhouse': STATIC_ASSET_URL + "/social-icons/Clubhouse.svg",
    'Crunchbase': STATIC_ASSET_URL + "/social-icons/Crunchbase.svg",
    'Dribbble': STATIC_ASSET_URL + "/social-icons/Dribbble.svg",
    'Facebook': STATIC_ASSET_URL + "/social-icons/Facebook.svg",
    'Figma': STATIC_ASSET_URL + "/social-icons/Figma.svg",
    'GitHub': STATIC_ASSET_URL + "/social-icons/GitHub.svg",
    'Google': STATIC_ASSET_URL + "/social-icons/Google.svg",
    'Instagram': STATIC_ASSET_URL + "/social-icons/Instagram.svg",
    'LinkedIn': STATIC_ASSET_URL + "/social-icons/LinkedIn.svg",
    'Meta': STATIC_ASSET_URL + "/social-icons/Meta.svg",
    'Outreach': STATIC_ASSET_URL + "/social-icons/Outreach.svg",
    'Pinterest': STATIC_ASSET_URL + "/social-icons/Pinterest.svg",
    'Reddit': STATIC_ASSET_URL + "/social-icons/Reddit.svg",
    'SalesNavigator': STATIC_ASSET_URL + "/social-icons/SalesNavigator.svg",
    'Signal': STATIC_ASSET_URL + "/social-icons/Signal.svg",
    'Snapchat': STATIC_ASSET_URL + "/social-icons/Snapchat.svg",
    'Telegram': STATIC_ASSET_URL + "/social-icons/Telegram.svg",
    'Tumblr': STATIC_ASSET_URL + "/social-icons/Tumblr.svg",
    'Twitter': STATIC_ASSET_URL + "/social-icons/Twitter.svg",
    'Website': STATIC_ASSET_URL + "/social-icons/Website.svg",
    'YouTube': STATIC_ASSET_URL + "/social-icons/YouTube.svg",
};
exports.PaymentIconAsset = {
    'Affirm': STATIC_ASSET_URL + "/payment-icons/Affirm.svg",
    'Amazon': STATIC_ASSET_URL + "/payment-icons/Amazon.svg",
    'AMEX': STATIC_ASSET_URL + "/payment-icons/AMEX.svg",
    'ApplePay': STATIC_ASSET_URL + "/payment-icons/ApplePay.svg",
    'Bitcoin': STATIC_ASSET_URL + "/payment-icons/Bitcoin.svg",
    'BitcoinCash': STATIC_ASSET_URL + "/payment-icons/BitcoinCash.svg",
    'Discover': STATIC_ASSET_URL + "/payment-icons/Discover.svg",
    'Etherium': STATIC_ASSET_URL + "/payment-icons/Etherium.svg",
    'GooglePay': STATIC_ASSET_URL + "/payment-icons/GooglePay.svg",
    'Lightcoin': STATIC_ASSET_URL + "/payment-icons/Lightcoin.svg",
    'Maestro': STATIC_ASSET_URL + "/payment-icons/Maestro.svg",
    'Mastercard': STATIC_ASSET_URL + "/payment-icons/Mastercard.svg",
    'Payoneer': STATIC_ASSET_URL + "/payment-icons/Payoneer.svg",
    'PayPal': STATIC_ASSET_URL + "/payment-icons/PayPal.svg",
    'ShopPay': STATIC_ASSET_URL + "/payment-icons/ShopPay.svg",
    'Skrill': STATIC_ASSET_URL + "/payment-icons/Skrill.svg",
    'Stripe': STATIC_ASSET_URL + "/payment-icons/Stripe.svg",
    'Verifone': STATIC_ASSET_URL + "/payment-icons/Verifone.svg",
    'Visa': STATIC_ASSET_URL + "/payment-icons/Visa.svg",
    'Yandex': STATIC_ASSET_URL + "/payment-icons/Yandex.svg",
};
exports.CountryIconAsset = {
    'AD': STATIC_ASSET_URL + "/country-icons/AD.svg",
    'AE': STATIC_ASSET_URL + "/country-icons/AE.svg",
    'AF': STATIC_ASSET_URL + "/country-icons/AF.svg",
    'AG': STATIC_ASSET_URL + "/country-icons/AG.svg",
    'AI': STATIC_ASSET_URL + "/country-icons/AI.svg",
    'AL': STATIC_ASSET_URL + "/country-icons/AL.svg",
    'AM': STATIC_ASSET_URL + "/country-icons/AM.svg",
    'AO': STATIC_ASSET_URL + "/country-icons/AO.svg",
    'AR': STATIC_ASSET_URL + "/country-icons/AR.svg",
    'AS': STATIC_ASSET_URL + "/country-icons/AS.svg",
    'AT': STATIC_ASSET_URL + "/country-icons/AT.svg",
    'AU': STATIC_ASSET_URL + "/country-icons/AU.svg",
    'AW': STATIC_ASSET_URL + "/country-icons/AW.svg",
    'AX': STATIC_ASSET_URL + "/country-icons/AX.svg",
    'AZ': STATIC_ASSET_URL + "/country-icons/AZ.svg",
    'BA': STATIC_ASSET_URL + "/country-icons/BA.svg",
    'BB': STATIC_ASSET_URL + "/country-icons/BB.svg",
    'BD': STATIC_ASSET_URL + "/country-icons/BD.svg",
    'BE': STATIC_ASSET_URL + "/country-icons/BE.svg",
    'BF': STATIC_ASSET_URL + "/country-icons/BF.svg",
    'BG': STATIC_ASSET_URL + "/country-icons/BG.svg",
    'BH': STATIC_ASSET_URL + "/country-icons/BH.svg",
    'BI': STATIC_ASSET_URL + "/country-icons/BI.svg",
    'BJ': STATIC_ASSET_URL + "/country-icons/BJ.svg",
    'BL': STATIC_ASSET_URL + "/country-icons/BL.svg",
    'BM': STATIC_ASSET_URL + "/country-icons/BM.svg",
    'BN': STATIC_ASSET_URL + "/country-icons/BN.svg",
    'BO': STATIC_ASSET_URL + "/country-icons/BO.svg",
    'BQ-1': STATIC_ASSET_URL + "/country-icons/BQ-1.svg",
    'BQ-2': STATIC_ASSET_URL + "/country-icons/BQ-2.svg",
    'BQ': STATIC_ASSET_URL + "/country-icons/BQ.svg",
    'BR': STATIC_ASSET_URL + "/country-icons/BR.svg",
    'BS': STATIC_ASSET_URL + "/country-icons/BS.svg",
    'BT': STATIC_ASSET_URL + "/country-icons/BT.svg",
    'BW': STATIC_ASSET_URL + "/country-icons/BW.svg",
    'BY': STATIC_ASSET_URL + "/country-icons/BY.svg",
    'BZ': STATIC_ASSET_URL + "/country-icons/BZ.svg",
    'CA': STATIC_ASSET_URL + "/country-icons/CA.svg",
    'CC': STATIC_ASSET_URL + "/country-icons/CC.svg",
    'CD-1': STATIC_ASSET_URL + "/country-icons/CD-1.svg",
    'CD': STATIC_ASSET_URL + "/country-icons/CD.svg",
    'CF': STATIC_ASSET_URL + "/country-icons/CF.svg",
    'CH': STATIC_ASSET_URL + "/country-icons/CH.svg",
    'CK': STATIC_ASSET_URL + "/country-icons/CK.svg",
    'CL': STATIC_ASSET_URL + "/country-icons/CL.svg",
    'CM': STATIC_ASSET_URL + "/country-icons/CM.svg",
    'CN': STATIC_ASSET_URL + "/country-icons/CN.svg",
    'CO': STATIC_ASSET_URL + "/country-icons/CO.svg",
    'CR': STATIC_ASSET_URL + "/country-icons/CR.svg",
    'CU': STATIC_ASSET_URL + "/country-icons/CU.svg",
    'CW': STATIC_ASSET_URL + "/country-icons/CW.svg",
    'CX': STATIC_ASSET_URL + "/country-icons/CX.svg",
    'CY': STATIC_ASSET_URL + "/country-icons/CY.svg",
    'CZ': STATIC_ASSET_URL + "/country-icons/CZ.svg",
    'DE': STATIC_ASSET_URL + "/country-icons/DE.svg",
    'DJ': STATIC_ASSET_URL + "/country-icons/DJ.svg",
    'DK': STATIC_ASSET_URL + "/country-icons/DK.svg",
    'DM': STATIC_ASSET_URL + "/country-icons/DM.svg",
    'DO': STATIC_ASSET_URL + "/country-icons/DO.svg",
    'DS': STATIC_ASSET_URL + "/country-icons/DS.svg",
    'DZ': STATIC_ASSET_URL + "/country-icons/DZ.svg",
    'EC': STATIC_ASSET_URL + "/country-icons/EC.svg",
    'EE': STATIC_ASSET_URL + "/country-icons/EE.svg",
    'EG': STATIC_ASSET_URL + "/country-icons/EG.svg",
    'EH': STATIC_ASSET_URL + "/country-icons/EH.svg",
    'ER': STATIC_ASSET_URL + "/country-icons/ER.svg",
    'ES': STATIC_ASSET_URL + "/country-icons/ES.svg",
    'ET': STATIC_ASSET_URL + "/country-icons/ET.svg",
    'FI': STATIC_ASSET_URL + "/country-icons/FI.svg",
    'FJ': STATIC_ASSET_URL + "/country-icons/FJ.svg",
    'FK': STATIC_ASSET_URL + "/country-icons/FK.svg",
    'FM': STATIC_ASSET_URL + "/country-icons/FM.svg",
    'FO': STATIC_ASSET_URL + "/country-icons/FO.svg",
    'FR': STATIC_ASSET_URL + "/country-icons/FR.svg",
    'GA': STATIC_ASSET_URL + "/country-icons/GA.svg",
    'GB-2': STATIC_ASSET_URL + "/country-icons/GB-2.svg",
    'GB': STATIC_ASSET_URL + "/country-icons/GB.svg",
    'GD': STATIC_ASSET_URL + "/country-icons/GD.svg",
    'GE': STATIC_ASSET_URL + "/country-icons/GE.svg",
    'GG': STATIC_ASSET_URL + "/country-icons/GG.svg",
    'GH': STATIC_ASSET_URL + "/country-icons/GH.svg",
    'GI': STATIC_ASSET_URL + "/country-icons/GI.svg",
    'GL': STATIC_ASSET_URL + "/country-icons/GL.svg",
    'GM': STATIC_ASSET_URL + "/country-icons/GM.svg",
    'GN': STATIC_ASSET_URL + "/country-icons/GN.svg",
    'GQ': STATIC_ASSET_URL + "/country-icons/GQ.svg",
    'GR': STATIC_ASSET_URL + "/country-icons/GR.svg",
    'GT': STATIC_ASSET_URL + "/country-icons/GT.svg",
    'GU': STATIC_ASSET_URL + "/country-icons/GU.svg",
    'GW': STATIC_ASSET_URL + "/country-icons/GW.svg",
    'GY': STATIC_ASSET_URL + "/country-icons/GY.svg",
    'HK': STATIC_ASSET_URL + "/country-icons/HK.svg",
    'HN': STATIC_ASSET_URL + "/country-icons/HN.svg",
    'HR': STATIC_ASSET_URL + "/country-icons/HR.svg",
    'HT': STATIC_ASSET_URL + "/country-icons/HT.svg",
    'HU': STATIC_ASSET_URL + "/country-icons/HU.svg",
    'ID': STATIC_ASSET_URL + "/country-icons/ID.svg",
    'IE': STATIC_ASSET_URL + "/country-icons/IE.svg",
    'IL': STATIC_ASSET_URL + "/country-icons/IL.svg",
    'IM': STATIC_ASSET_URL + "/country-icons/IM.svg",
    'IN': STATIC_ASSET_URL + "/country-icons/IN.svg",
    'IO': STATIC_ASSET_URL + "/country-icons/IO.svg",
    'IQ': STATIC_ASSET_URL + "/country-icons/IQ.svg",
    'IR': STATIC_ASSET_URL + "/country-icons/IR.svg",
    'IS': STATIC_ASSET_URL + "/country-icons/IS.svg",
    'IT': STATIC_ASSET_URL + "/country-icons/IT.svg",
    'JE': STATIC_ASSET_URL + "/country-icons/JE.svg",
    'JM': STATIC_ASSET_URL + "/country-icons/JM.svg",
    'JO': STATIC_ASSET_URL + "/country-icons/JO.svg",
    'JP': STATIC_ASSET_URL + "/country-icons/JP.svg",
    'KE': STATIC_ASSET_URL + "/country-icons/KE.svg",
    'KG': STATIC_ASSET_URL + "/country-icons/KG.svg",
    'KH': STATIC_ASSET_URL + "/country-icons/KH.svg",
    'KI': STATIC_ASSET_URL + "/country-icons/KI.svg",
    'KM': STATIC_ASSET_URL + "/country-icons/KM.svg",
    'KN': STATIC_ASSET_URL + "/country-icons/KN.svg",
    'KP': STATIC_ASSET_URL + "/country-icons/KP.svg",
    'KR': STATIC_ASSET_URL + "/country-icons/KR.svg",
    'KW': STATIC_ASSET_URL + "/country-icons/KW.svg",
    'KY': STATIC_ASSET_URL + "/country-icons/KY.svg",
    'KZ': STATIC_ASSET_URL + "/country-icons/KZ.svg",
    'LA': STATIC_ASSET_URL + "/country-icons/LA.svg",
    'LB': STATIC_ASSET_URL + "/country-icons/LB.svg",
    'LC': STATIC_ASSET_URL + "/country-icons/LC.svg",
    'LI': STATIC_ASSET_URL + "/country-icons/LI.svg",
    'LK': STATIC_ASSET_URL + "/country-icons/LK.svg",
    'LR': STATIC_ASSET_URL + "/country-icons/LR.svg",
    'LS': STATIC_ASSET_URL + "/country-icons/LS.svg",
    'LT': STATIC_ASSET_URL + "/country-icons/LT.svg",
    'LU': STATIC_ASSET_URL + "/country-icons/LU.svg",
    'LV': STATIC_ASSET_URL + "/country-icons/LV.svg",
    'LY': STATIC_ASSET_URL + "/country-icons/LY.svg",
    'MA': STATIC_ASSET_URL + "/country-icons/MA.svg",
    'MC': STATIC_ASSET_URL + "/country-icons/MC.svg",
    'MD': STATIC_ASSET_URL + "/country-icons/MD.svg",
    'ME': STATIC_ASSET_URL + "/country-icons/ME.svg",
    'MG': STATIC_ASSET_URL + "/country-icons/MG.svg",
    'MH': STATIC_ASSET_URL + "/country-icons/MH.svg",
    'MK': STATIC_ASSET_URL + "/country-icons/MK.svg",
    'ML': STATIC_ASSET_URL + "/country-icons/ML.svg",
    'MM': STATIC_ASSET_URL + "/country-icons/MM.svg",
    'MN': STATIC_ASSET_URL + "/country-icons/MN.svg",
    'MO': STATIC_ASSET_URL + "/country-icons/MO.svg",
    'MP': STATIC_ASSET_URL + "/country-icons/MP.svg",
    'MQ': STATIC_ASSET_URL + "/country-icons/MQ.svg",
    'MR': STATIC_ASSET_URL + "/country-icons/MR.svg",
    'MS': STATIC_ASSET_URL + "/country-icons/MS.svg",
    'MT': STATIC_ASSET_URL + "/country-icons/MT.svg",
    'MU': STATIC_ASSET_URL + "/country-icons/MU.svg",
    'MV': STATIC_ASSET_URL + "/country-icons/MV.svg",
    'MW': STATIC_ASSET_URL + "/country-icons/MW.svg",
    'MX': STATIC_ASSET_URL + "/country-icons/MX.svg",
    'MY': STATIC_ASSET_URL + "/country-icons/MY.svg",
    'MZ': STATIC_ASSET_URL + "/country-icons/MZ.svg",
    'NA': STATIC_ASSET_URL + "/country-icons/NA.svg",
    'NE': STATIC_ASSET_URL + "/country-icons/NE.svg",
    'NF': STATIC_ASSET_URL + "/country-icons/NF.svg",
    'NG': STATIC_ASSET_URL + "/country-icons/NG.svg",
    'NI': STATIC_ASSET_URL + "/country-icons/NI.svg",
    'NL': STATIC_ASSET_URL + "/country-icons/NL.svg",
    'NO': STATIC_ASSET_URL + "/country-icons/NO.svg",
    'NP': STATIC_ASSET_URL + "/country-icons/NP.svg",
    'NR': STATIC_ASSET_URL + "/country-icons/NR.svg",
    'NU': STATIC_ASSET_URL + "/country-icons/NU.svg",
    'NZ': STATIC_ASSET_URL + "/country-icons/NZ.svg",
    'OM': STATIC_ASSET_URL + "/country-icons/OM.svg",
    'PA': STATIC_ASSET_URL + "/country-icons/PA.svg",
    'PE': STATIC_ASSET_URL + "/country-icons/PE.svg",
    'PF': STATIC_ASSET_URL + "/country-icons/PF.svg",
    'PG': STATIC_ASSET_URL + "/country-icons/PG.svg",
    'PH': STATIC_ASSET_URL + "/country-icons/PH.svg",
    'PK': STATIC_ASSET_URL + "/country-icons/PK.svg",
    'PL': STATIC_ASSET_URL + "/country-icons/PL.svg",
    'PN': STATIC_ASSET_URL + "/country-icons/PN.svg",
    'PR': STATIC_ASSET_URL + "/country-icons/PR.svg",
    'PS': STATIC_ASSET_URL + "/country-icons/PS.svg",
    'PT': STATIC_ASSET_URL + "/country-icons/PT.svg",
    'PW': STATIC_ASSET_URL + "/country-icons/PW.svg",
    'PY': STATIC_ASSET_URL + "/country-icons/PY.svg",
    'QA': STATIC_ASSET_URL + "/country-icons/QA.svg",
    'RO': STATIC_ASSET_URL + "/country-icons/RO.svg",
    'RS': STATIC_ASSET_URL + "/country-icons/RS.svg",
    'RU': STATIC_ASSET_URL + "/country-icons/RU.svg",
    'RW': STATIC_ASSET_URL + "/country-icons/RW.svg",
    'SA': STATIC_ASSET_URL + "/country-icons/SA.svg",
    'SB': STATIC_ASSET_URL + "/country-icons/SB.svg",
    'SC': STATIC_ASSET_URL + "/country-icons/SC.svg",
    'SE': STATIC_ASSET_URL + "/country-icons/SE.svg",
    'SG': STATIC_ASSET_URL + "/country-icons/SG.svg",
    'SI': STATIC_ASSET_URL + "/country-icons/SI.svg",
    'SK': STATIC_ASSET_URL + "/country-icons/SK.svg",
    'SL': STATIC_ASSET_URL + "/country-icons/SL.svg",
    'SM': STATIC_ASSET_URL + "/country-icons/SM.svg",
    'SN': STATIC_ASSET_URL + "/country-icons/SN.svg",
    'SO': STATIC_ASSET_URL + "/country-icons/SO.svg",
    'SR': STATIC_ASSET_URL + "/country-icons/SR.svg",
    'SS': STATIC_ASSET_URL + "/country-icons/SS.svg",
    'ST': STATIC_ASSET_URL + "/country-icons/ST.svg",
    'SV': STATIC_ASSET_URL + "/country-icons/SV.svg",
    'SX': STATIC_ASSET_URL + "/country-icons/SX.svg",
    'SY': STATIC_ASSET_URL + "/country-icons/SY.svg",
    'SZ': STATIC_ASSET_URL + "/country-icons/SZ.svg",
    'TC': STATIC_ASSET_URL + "/country-icons/TC.svg",
    'TD': STATIC_ASSET_URL + "/country-icons/TD.svg",
    'TG': STATIC_ASSET_URL + "/country-icons/TG.svg",
    'TH': STATIC_ASSET_URL + "/country-icons/TH.svg",
    'TJ': STATIC_ASSET_URL + "/country-icons/TJ.svg",
    'TK': STATIC_ASSET_URL + "/country-icons/TK.svg",
    'TL': STATIC_ASSET_URL + "/country-icons/TL.svg",
    'TM': STATIC_ASSET_URL + "/country-icons/TM.svg",
    'TN': STATIC_ASSET_URL + "/country-icons/TN.svg",
    'TO': STATIC_ASSET_URL + "/country-icons/TO.svg",
    'TR': STATIC_ASSET_URL + "/country-icons/TR.svg",
    'TT': STATIC_ASSET_URL + "/country-icons/TT.svg",
    'TV': STATIC_ASSET_URL + "/country-icons/TV.svg",
    'TW': STATIC_ASSET_URL + "/country-icons/TW.svg",
    'TZ': STATIC_ASSET_URL + "/country-icons/TZ.svg",
    'UA': STATIC_ASSET_URL + "/country-icons/UA.svg",
    'UG': STATIC_ASSET_URL + "/country-icons/UG.svg",
    'US': STATIC_ASSET_URL + "/country-icons/US.svg",
    'UY': STATIC_ASSET_URL + "/country-icons/UY.svg",
    'UZ': STATIC_ASSET_URL + "/country-icons/UZ.svg",
    'VC': STATIC_ASSET_URL + "/country-icons/VC.svg",
    'VE': STATIC_ASSET_URL + "/country-icons/VE.svg",
    'VG': STATIC_ASSET_URL + "/country-icons/VG.svg",
    'VI': STATIC_ASSET_URL + "/country-icons/VI.svg",
    'VN': STATIC_ASSET_URL + "/country-icons/VN.svg",
    'VU': STATIC_ASSET_URL + "/country-icons/VU.svg",
    'WS': STATIC_ASSET_URL + "/country-icons/WS.svg",
    'YE': STATIC_ASSET_URL + "/country-icons/YE.svg",
    'ZA': STATIC_ASSET_URL + "/country-icons/ZA.svg",
    'ZM': STATIC_ASSET_URL + "/country-icons/ZM.svg",
    'ZW': STATIC_ASSET_URL + "/country-icons/ZW.svg",
};
exports.CompanySymbolAsset = {
    'adobe': STATIC_ASSET_URL + "/company-symbols/adobe.svg",
    'amazon': STATIC_ASSET_URL + "/company-symbols/amazon.svg",
    'amd': STATIC_ASSET_URL + "/company-symbols/amd.svg",
    'american_express': STATIC_ASSET_URL + "/company-symbols/american_express.svg",
    'android': STATIC_ASSET_URL + "/company-symbols/android.svg",
    'app_store': STATIC_ASSET_URL + "/company-symbols/app_store.svg",
    'apple': STATIC_ASSET_URL + "/company-symbols/apple.svg",
    'atlassian': STATIC_ASSET_URL + "/company-symbols/atlassian.svg",
    'behance': STATIC_ASSET_URL + "/company-symbols/behance.svg",
    'bluetooth': STATIC_ASSET_URL + "/company-symbols/bluetooth.svg",
    'chrome': STATIC_ASSET_URL + "/company-symbols/chrome.svg",
    'confluence': STATIC_ASSET_URL + "/company-symbols/confluence.svg",
    'dell': STATIC_ASSET_URL + "/company-symbols/dell.svg",
    'dribbble': STATIC_ASSET_URL + "/company-symbols/dribbble.svg",
    'dropbox': STATIC_ASSET_URL + "/company-symbols/dropbox.svg",
    'edge': STATIC_ASSET_URL + "/company-symbols/edge.svg",
    'Facebook': STATIC_ASSET_URL + "/company-symbols/Facebook.svg",
    'facetime': STATIC_ASSET_URL + "/company-symbols/facetime.svg",
    'figma': STATIC_ASSET_URL + "/company-symbols/figma.svg",
    'firefox': STATIC_ASSET_URL + "/company-symbols/firefox.svg",
    'framer': STATIC_ASSET_URL + "/company-symbols/framer.svg",
    'g-calendar': STATIC_ASSET_URL + "/company-symbols/g-calendar.svg",
    'general_electric': STATIC_ASSET_URL + "/company-symbols/general_electric.svg",
    'github': STATIC_ASSET_URL + "/company-symbols/github.svg",
    'gitlab': STATIC_ASSET_URL + "/company-symbols/gitlab.svg",
    'gmail': STATIC_ASSET_URL + "/company-symbols/gmail.svg",
    'google docs': STATIC_ASSET_URL + "/company-symbols/google docs.svg",
    'google maps': STATIC_ASSET_URL + "/company-symbols/google maps.svg",
    'google meet': STATIC_ASSET_URL + "/company-symbols/google meet.svg",
    'google_ads': STATIC_ASSET_URL + "/company-symbols/google_ads.svg",
    'google_drive': STATIC_ASSET_URL + "/company-symbols/google_drive.svg",
    'google_hangouts': STATIC_ASSET_URL + "/company-symbols/google_hangouts.svg",
    'google_play': STATIC_ASSET_URL + "/company-symbols/google_play.svg",
    'google': STATIC_ASSET_URL + "/company-symbols/google.svg",
    'hubspot': STATIC_ASSET_URL + "/company-symbols/hubspot.svg",
    'ibm': STATIC_ASSET_URL + "/company-symbols/ibm.svg",
    'igtv': STATIC_ASSET_URL + "/company-symbols/igtv.svg",
    'instagram': STATIC_ASSET_URL + "/company-symbols/instagram.svg",
    'intel': STATIC_ASSET_URL + "/company-symbols/intel.svg",
    'intercom': STATIC_ASSET_URL + "/company-symbols/intercom.svg",
    'invision': STATIC_ASSET_URL + "/company-symbols/invision.svg",
    'ios': STATIC_ASSET_URL + "/company-symbols/ios.svg",
    'jira': STATIC_ASSET_URL + "/company-symbols/jira.svg",
    'linkedin': STATIC_ASSET_URL + "/company-symbols/linkedin.svg",
    'loom': STATIC_ASSET_URL + "/company-symbols/loom.svg",
    'mailchimp': STATIC_ASSET_URL + "/company-symbols/mailchimp.svg",
    'marketo': STATIC_ASSET_URL + "/company-symbols/marketo.svg",
    'mastercard': STATIC_ASSET_URL + "/company-symbols/mastercard.svg",
    'medium': STATIC_ASSET_URL + "/company-symbols/medium.svg",
    'messages': STATIC_ASSET_URL + "/company-symbols/messages.svg",
    'microsoft': STATIC_ASSET_URL + "/company-symbols/microsoft.svg",
    'ms_dynamics': STATIC_ASSET_URL + "/company-symbols/ms_dynamics.svg",
    'ms_skype': STATIC_ASSET_URL + "/company-symbols/ms_skype.svg",
    'opera': STATIC_ASSET_URL + "/company-symbols/opera.svg",
    'patreon': STATIC_ASSET_URL + "/company-symbols/patreon.svg",
    'paypal': STATIC_ASSET_URL + "/company-symbols/paypal.svg",
    'pinterest': STATIC_ASSET_URL + "/company-symbols/pinterest.svg",
    'product_hunt': STATIC_ASSET_URL + "/company-symbols/product_hunt.svg",
    'quora': STATIC_ASSET_URL + "/company-symbols/quora.svg",
    'reddit': STATIC_ASSET_URL + "/company-symbols/reddit.svg",
    'safari': STATIC_ASSET_URL + "/company-symbols/safari.svg",
    'salesforce': STATIC_ASSET_URL + "/company-symbols/salesforce.svg",
    'saleswhale': STATIC_ASSET_URL + "/company-symbols/saleswhale.svg",
    'shopify': STATIC_ASSET_URL + "/company-symbols/shopify.svg",
    'sketch': STATIC_ASSET_URL + "/company-symbols/sketch.svg",
    'slack': STATIC_ASSET_URL + "/company-symbols/slack.svg",
    'spectrum': STATIC_ASSET_URL + "/company-symbols/spectrum.svg",
    'stack_overflow': STATIC_ASSET_URL + "/company-symbols/stack_overflow.svg",
    'stripe': STATIC_ASSET_URL + "/company-symbols/stripe.svg",
    'swift': STATIC_ASSET_URL + "/company-symbols/swift.svg",
    'tech_crunch': STATIC_ASSET_URL + "/company-symbols/tech_crunch.svg",
    'telegram': STATIC_ASSET_URL + "/company-symbols/telegram.svg",
    'trello': STATIC_ASSET_URL + "/company-symbols/trello.svg",
    'trustradius-1': STATIC_ASSET_URL + "/company-symbols/trustradius-1.svg",
    'trustradius': STATIC_ASSET_URL + "/company-symbols/trustradius.svg",
    'tumbler': STATIC_ASSET_URL + "/company-symbols/tumbler.svg",
    'twitch': STATIC_ASSET_URL + "/company-symbols/twitch.svg",
    'twitter': STATIC_ASSET_URL + "/company-symbols/twitter.svg",
    'vimeo': STATIC_ASSET_URL + "/company-symbols/vimeo.svg",
    'visa': STATIC_ASSET_URL + "/company-symbols/visa.svg",
    'vk': STATIC_ASSET_URL + "/company-symbols/vk.svg",
    'western_union': STATIC_ASSET_URL + "/company-symbols/western_union.svg",
    'whatsapp': STATIC_ASSET_URL + "/company-symbols/whatsapp.svg",
    'youtube': STATIC_ASSET_URL + "/company-symbols/youtube.svg",
    'zapier': STATIC_ASSET_URL + "/company-symbols/zapier.svg",
    'zendesk': STATIC_ASSET_URL + "/company-symbols/zendesk.svg",
    'zeplin': STATIC_ASSET_URL + "/company-symbols/zeplin.svg",
    'zoom': STATIC_ASSET_URL + "/company-symbols/zoom.svg",
};
exports.CompanyLogoAsset = {
    '6sense': STATIC_ASSET_URL + "/company-logos/6sense.svg",
    'Adobe': STATIC_ASSET_URL + "/company-logos/Adobe.svg",
    'Airtable': STATIC_ASSET_URL + "/company-logos/Airtable.svg",
    'Amazon': STATIC_ASSET_URL + "/company-logos/Amazon.svg",
    'Atlassian': STATIC_ASSET_URL + "/company-logos/Atlassian.svg",
    'Bombora': STATIC_ASSET_URL + "/company-logos/Bombora.svg",
    'Calendly': STATIC_ASSET_URL + "/company-logos/Calendly.svg",
    'Carta': STATIC_ASSET_URL + "/company-logos/Carta.svg",
    'Clearbit': STATIC_ASSET_URL + "/company-logos/Clearbit.svg",
    'Docusign': STATIC_ASSET_URL + "/company-logos/Docusign.svg",
    'DoorDash': STATIC_ASSET_URL + "/company-logos/DoorDash.svg",
    'Dropbox': STATIC_ASSET_URL + "/company-logos/Dropbox.svg",
    'Facebook': STATIC_ASSET_URL + "/company-logos/Facebook.svg",
    'Freshworks': STATIC_ASSET_URL + "/company-logos/Freshworks.svg",
    'GitHub': STATIC_ASSET_URL + "/company-logos/GitHub.svg",
    'Gitlab': STATIC_ASSET_URL + "/company-logos/Gitlab.svg",
    'Google': STATIC_ASSET_URL + "/company-logos/Google.svg",
    'Hotjar': STATIC_ASSET_URL + "/company-logos/Hotjar.svg",
    'Hubspot': STATIC_ASSET_URL + "/company-logos/Hubspot.svg",
    'Intercom': STATIC_ASSET_URL + "/company-logos/Intercom.svg",
    'InVision': STATIC_ASSET_URL + "/company-logos/InVision.svg",
    'Lattice': STATIC_ASSET_URL + "/company-logos/Lattice.svg",
    'Linkedin': STATIC_ASSET_URL + "/company-logos/Linkedin.svg",
    'Marketo': STATIC_ASSET_URL + "/company-logos/Marketo.svg",
    'Microsoft': STATIC_ASSET_URL + "/company-logos/Microsoft.svg",
    'Oracle': STATIC_ASSET_URL + "/company-logos/Oracle.svg",
    'Outreach': STATIC_ASSET_URL + "/company-logos/Outreach.svg",
    'PayPal': STATIC_ASSET_URL + "/company-logos/PayPal.svg",
    'Pendo': STATIC_ASSET_URL + "/company-logos/Pendo.svg",
    'Pipedrive': STATIC_ASSET_URL + "/company-logos/Pipedrive.svg",
    'Razorpay': STATIC_ASSET_URL + "/company-logos/Razorpay.svg",
    'Salesforce': STATIC_ASSET_URL + "/company-logos/Salesforce.svg",
    'SalesforcePardot': STATIC_ASSET_URL + "/company-logos/SalesforcePardot.svg",
    'Salesloft': STATIC_ASSET_URL + "/company-logos/Salesloft.svg",
    'Saleswhale': STATIC_ASSET_URL + "/company-logos/Saleswhale.svg",
    'Segment': STATIC_ASSET_URL + "/company-logos/Segment.svg",
    'Shopify': STATIC_ASSET_URL + "/company-logos/Shopify.svg",
    'Slack': STATIC_ASSET_URL + "/company-logos/Slack.svg",
    'Stripe': STATIC_ASSET_URL + "/company-logos/Stripe.svg",
    'Trello': STATIC_ASSET_URL + "/company-logos/Trello.svg",
    'Trustradius': STATIC_ASSET_URL + "/company-logos/Trustradius.svg",
    'Whatsapp': STATIC_ASSET_URL + "/company-logos/Whatsapp.svg",
    'YouTube': STATIC_ASSET_URL + "/company-logos/YouTube.svg",
    'Zapier': STATIC_ASSET_URL + "/company-logos/Zapier.svg",
    'Zoom': STATIC_ASSET_URL + "/company-logos/Zoom.svg",
};
exports.PublishedSegmentExampleAsset = {
    'account-details': STATIC_ASSET_URL + "/published-segment-examples/account-details.png",
    'orchestration': STATIC_ASSET_URL + "/published-segment-examples/orchestration.png",
    'sales-intelligence': STATIC_ASSET_URL + "/published-segment-examples/sales-intelligence.png",
    'sixsense-api-response': STATIC_ASSET_URL + "/published-segment-examples/sixsense-api-response.png",
};
exports.FeatureIconAsset = {
    'Advertising': STATIC_ASSET_URL + "/feature-icons/Advertising.svg",
    'Alerts': STATIC_ASSET_URL + "/feature-icons/Alerts.svg",
    'AudienceWorkflow': STATIC_ASSET_URL + "/feature-icons/AudienceWorkflow.svg",
    'DataWorkflow': STATIC_ASSET_URL + "/feature-icons/DataWorkflow.svg",
    'Orchestrations': STATIC_ASSET_URL + "/feature-icons/Orchestrations.svg",
    'PerformanceReport': STATIC_ASSET_URL + "/feature-icons/PerformanceReport.svg",
    'PublishedSegments': STATIC_ASSET_URL + "/feature-icons/PublishedSegments.svg",
};
